import { createSlice } from '@reduxjs/toolkit';

let initialState = {
    loading: false,
    getRes: null,
    countRes: null,
    assignRes: null,
    batchAssignRes: null,
    discardRes: null,
};

const slice = createSlice({
    name: 'labUnmatchedResult',
    initialState,
    reducers: {
        getUnmatchedResultsRequest: (state) => { state.loading = true; },
        getUnmatchedResultsSuccess: (state, action) => { state.loading = false; state.getRes = action.payload; },
        getUnmatchedResultsFailure: (state, action) => { state.loading = false; state.getRes = action.payload; },
        resetGetUnmatchedResults: (state) => { state.getRes = null; },

        getUnmatchedResultsCountRequest: (state) => { },
        getUnmatchedResultsCountSuccess: (state, action) => { state.countRes = action.payload; },
        getUnmatchedResultsCountFailure: (state, action) => { state.countRes = action.payload; },
        resetGetUnmatchedResultsCount: (state) => { state.countRes = null; },

        assignUnmatchedResultRequest: (state) => { state.loading = true; },
        assignUnmatchedResultSuccess: (state, action) => { state.loading = false; state.assignRes = action.payload; },
        assignUnmatchedResultFailure: (state, action) => { state.loading = false; state.assignRes = action.payload; },
        resetAssignUnmatchedResult: (state) => { state.assignRes = null; },

        batchAssignUnmatchedResultRequest: (state) => { state.loading = true; },
        batchAssignUnmatchedResultSuccess: (state, action) => { state.loading = false; state.batchAssignRes = action.payload; },
        batchAssignUnmatchedResultFailure: (state, action) => { state.loading = false; state.batchAssignRes = action.payload; },
        resetBatchAssignUnmatchedResult: (state) => { state.batchAssignRes = null; },

        discardUnmatchedResultRequest: (state) => { state.loading = true; },
        discardUnmatchedResultSuccess: (state, action) => { state.loading = false; state.discardRes = action.payload; },
        discardUnmatchedResultFailure: (state, action) => { state.loading = false; state.discardRes = action.payload; },
        resetDiscardUnmatchedResult: (state) => { state.discardRes = null; },
    }
});

export const {
    getUnmatchedResultsRequest, getUnmatchedResultsSuccess, getUnmatchedResultsFailure, resetGetUnmatchedResults,
    getUnmatchedResultsCountRequest, getUnmatchedResultsCountSuccess, getUnmatchedResultsCountFailure, resetGetUnmatchedResultsCount,
    assignUnmatchedResultRequest, assignUnmatchedResultSuccess, assignUnmatchedResultFailure, resetAssignUnmatchedResult,
    batchAssignUnmatchedResultRequest, batchAssignUnmatchedResultSuccess, batchAssignUnmatchedResultFailure, resetBatchAssignUnmatchedResult,
    discardUnmatchedResultRequest, discardUnmatchedResultSuccess, discardUnmatchedResultFailure, resetDiscardUnmatchedResult,
} = slice.actions;

export default slice.reducer;
